const useProfile = ()=>{

    let user = {id:localStorage.getItem('id'), agent_id:localStorage.getItem('agent_id'), name:localStorage.getItem('name'), email:localStorage.getItem('email'), phone:localStorage.getItem('phone'), avatar:localStorage.getItem('passport'), company:localStorage.getItem('company'), logo:localStorage.getItem('logo')}

    return user;
}

export default useProfile;